import React, {useEffect, useState} from 'react';
import axios from "axios";

export const useFavorite = () => {
    const [favorites, setFavorites] = useState([]);

    useEffect(() => {
        // Load favorites from localStorage if available
        const storedFavorites = JSON.parse(localStorage.getItem('favorites'));
        if (storedFavorites) {
            setFavorites(storedFavorites);
        }
    }, []);

    const loadFavorites = (itemId) => {
        axios.get('/api/favorites', {
            withCredentials: true,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            validateStatus: function (status) {
                return status < 500;
            },
        }).then(response => {
            setFavorites(response.data);
            localStorage.setItem('favorites', JSON.stringify(response.data));
        });
    };

    const addFavorite = (itemId) => {
        axios.post('/api/favorites', { item_id: itemId }, {
            withCredentials: true,
            validateStatus: function (status) {
                return status < 500;
            },
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
        }).then(response => {
            const storedFavorites = JSON.parse(localStorage.getItem('favorites')) || [];
            const updatedFavorites = [...storedFavorites, itemId];

            localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
            setFavorites(updatedFavorites);
        });
    };

    const removeFavorite = (itemId) => {
        axios.delete(`/api/favorites/${itemId}`, {
            withCredentials: true,
            validateStatus: function (status) {
                return status < 500;
            },
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
        }).then(() => {
            const storedFavorites = JSON.parse(localStorage.getItem('favorites')) || [];
            const updatedFavorites = storedFavorites.filter(id => id !== itemId);

            localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
            setFavorites(updatedFavorites);
        });
    };

    const isFavorite = (itemId) => {
        return favorites.includes(itemId);
    };

    return {
        favorites,
        loadFavorites,
        addFavorite,
        removeFavorite,
        isFavorite,
    };
};
